
export class UpdateDevieModel {
  userId: string;
  name: string;
}
